import React, {useEffect, useContext, useState, Fragment} from 'react';
import { PageSettings } from './../../config/page-settings.js';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';


const FormPreview = props => {

  let contextType = useContext(PageSettings);
  const [dataModule, setModule] = useState([])


  useEffect(() => {
    let dataState = localStorage.getItem('subModule');

    const stateParams = JSON.parse(dataState);
    const { subModule } = stateParams;

    setModule(subModule);
    contextType.handleSetPageSidebar(false);
		contextType.handleSetPageHeader(false);
		contextType.handleSetBodyWhiteBg(true);
  }, []);

  return(
    <Panel>
      <PanelHeader noButton>Preview Table </PanelHeader>
      <PanelBody>
        { dataModule.map(item => {
          return RenderTable(item)
        })}
      </PanelBody>
    </Panel>
  )
}


const RenderTable = (item) => {
  const headerData = NormalizeHeaderData(item.xItem);
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle"}}>No</td>
                <td rowspan={3} style={{ textAlign: "center", verticalAlign: "middle"}}>{item.name}</td>
                {RenderHeader(item.xItem, headerData)}
              </tr>

              {RenderSubHeader(headerData)}

            </thead>
            <tbody>
              {RenderBody(item.xItem, item.yItem)}
            </tbody>
          </table>
        </div>
    </div>
  )
}

const countColSpan = item => {
  let colHeader = 0;

  item.sub.forEach(value => {
    if(value.sub.length > 0) {
      colHeader = colHeader + value.sub.length;
    } else {
      colHeader++;
    }
  });

  return colHeader;
}

const RenderHeader = (subModule, headerData) => {
  return subModule.map(item => {
    const colHeader = countColSpan(item);

    return (
      <th 
        colspan={colHeader}
        style={{ textAlign: "center", verticalAlign: "middle"}}
        rowspan={item.sub.length === 0 && 3}
      >{item.name}{renderMinMax(item.thresholdMax, item.thresholdMin)}
      </th>
    )
  })
}

const renderMinMax = (thresholdMax, thresholdMin) => {
  if (thresholdMax === null && thresholdMin === null) {
    return null;
  } else {
    return (
      <Fragment>
        <br></br>Min {thresholdMin} Max {thresholdMax}
      </Fragment>
    )
  }
}

const NormalizeHeaderData = (subModule) => {
  const dataArr = [];
  let arr1 = [];
  let arr2 = [];

  subModule.forEach(item => {
    if(item.sub.length > 0){
      item.sub.forEach((item2, idx, arr) => {
        const isHaveSub = arr.find(value => value.sub.length > 0);
        const { name, thresholdMax = '', thresholdMin = '' } = item2;
        const data1 = {
          name,
          colSpan: item2.sub.length,
          thresholdMax,
          thresholdMin
        }
        arr1.push(data1);
        if(item2.sub.length > 0){
          item2.sub.forEach(item3 => {
            const { name, thresholdMax = '', thresholdMin = '' } = item3;
            const data2 = {
              name,
              colSpan: item3.sub.length,
              thresholdMax,
              thresholdMin
            }
            arr2.push(data2);
          })
        } else if(isHaveSub) {
          const data2 = {
            name : '',
            colSpan: 1,
            thresholdMax,
            thresholdMin
          }
          arr2.push(data2);
        }
      })
    }
  });

  dataArr.push(arr1);
  dataArr.push(arr2);

  return dataArr;
}

const RenderSubHeader = (subModule) => {
  return subModule.map(xItem => {
    return (
      <tr>
        {xItem.map(item => {
          return <th colSpan={item.colSpan} style={{ textAlign: "center"}}>{item.name}</th>
        })}
      </tr>
    )
  })
}

const RenderBody = (xItem, yItem) => {
  return yItem.items.map((item, idx) => {
    return (
      <tr>
        <td style={{ textAlign: "center"}}>{idx+1}</td>
        <td >{item.name}</td>
        {xItem.map(item2 => {
          if(item2.sub.length > 0) {
            return item2.sub.map(item3 => {
              if(item3.sub.length > 0) {
                return item3.sub.map(item4 => {return <td colSpan="1">{item4.value}</td>})
              } else {
                return <td colSpan="1">{item3.value}</td>
              }
            })
          } else {
            return <td colSpan="1">{item2.value}</td>
          }
        })}
      </tr>
    )
  })
}



export default FormPreview;